import { combineReducers } from "redux";
import { handleActions } from "redux-actions";
import { CONTACTS } from "constants/action-types";
import {
    fetchActions,
    initialBaseState,
    updateActions,
    IFetchStoreState,
    updateProgressActions,
    IUpdateStoreState,
} from "./base-reducers";
import { ICompanyApi, ICompany, IContact } from "components/contacts/contacts-types";
import { IHeader } from "constants/table-types";

type FetchUpdateState<T> = IFetchStoreState<T> & IUpdateStoreState<T>;

export interface IContactsState {
    accounts: IFetchStoreState<IContact[]>;
    buyer: FetchUpdateState<IContact>;
    company: FetchUpdateState<ICompany>;
    api: IFetchStoreState<ICompanyApi>;
    headers: IFetchStoreState<IHeader[]>;
}

export const contacts = combineReducers<IContactsState>({
    accounts: handleActions<IFetchStoreState<IContact[]>>(
        {
            ...fetchActions(CONTACTS.ACCOUNTS.FETCH),
            ...updateActions(CONTACTS.ACCOUNTS),
        } as any,
        initialBaseState
    ),
    buyer: handleActions<FetchUpdateState<IContact>>(
        {
            ...fetchActions(CONTACTS.BUYER.FETCH),
            ...updateProgressActions(CONTACTS.BUYER.UPDATE),
        } as any,
        initialBaseState
    ),
    company: handleActions<FetchUpdateState<ICompany>>(
        {
            ...fetchActions(CONTACTS.COMPANY.FETCH),
            ...updateProgressActions(CONTACTS.COMPANY.UPDATE),
        } as any,
        initialBaseState
    ),
    api: handleActions<IFetchStoreState<ICompanyApi>>(
        {
            ...updateActions(CONTACTS.COMPANY.API),
        } as any,
        initialBaseState
    ),
    headers: handleActions<IFetchStoreState<IHeader[]>>(
        {
            ...fetchActions(CONTACTS.HEADERS.FETCH),
        } as any,
        initialBaseState
    ),
});
